



// a state controller for import
function ModuleImportController(ListContext, TemplateObject, FormService, $state, $stateParams, $scope, $q, $timeout, GridHelpers, $translate) {
	var self = this;

	this.ListContext = ListContext;
	this.TemplateObject = TemplateObject;
	this.Class = ListContext.getClass();  // Person
	this.EffectiveTime = ListContext.getEffectiveTime();  // null
	this.title = ListContext.getListTitle();
	this.name = ListContext.getName();
	this.icon = ListContext.getIcon();
	this.gridId = ListContext.Parent? (this.name + '-import-' + ListContext.Parent.getClass().name) : this.name;
	this.activeTab = 0;
	this.preset = $stateParams.preset
	this.import_config = this.Class.import_config[this.preset]
	this.import_title = this.import_config.title != 'Import' ? this.import_config.title : null;

	this.items = [];
	this.results = [];
	this.deleted_items = [];
	this.values = {
		csv_text: "",
		delete_unlisted: false,
		merge_objects: false,
	}
	this.fieldGroup = this.import_config.group
	this.importFields = this.Class.get_form_params(null, self.Class.get_fields(this.fieldGroup), {edit: true, view:true})
	this.importColumns = []
	this.columnFieldnames = [];
	this.gridOptions = GridHelpers.makeGridOptions({
		enableServerSideSorting: false,
		enableSorting: true,
		enableFilter: true,
		suppressCellSelection: true,  // do not click individual cells
		rowSelection: 'single',
		angularCompileRows: false,  // sloow
		colWidth: 170,
		rowData: null,
		columnDefs: [
			{
				headerName: $translate.instant('Import status'), 
				field: '__index',
				valueGetter: function(params) {
					var __index = params.data.__index;
					var label = 'Ready to import';
					if (!self.results[__index]) {
						return $translate.instant('Ready to import');
					} else {
						if (self.results[__index].created) {
							return $translate.instant('Created');
						}
						if (self.results[__index].updated) {
							return $translate.instant('Updated');
						}
						if (self.results[__index].data) {
							var output = [];
							for (var fieldname in self.results[__index].data) {
								if (self.import_config.columns[fieldname]) {
									// it is possible not to find columns if presets get conflicted
									var error = self.results[__index].data[fieldname];
									var cols = self.import_config.columns[fieldname].join(', ')
									output.push(cols + ": " + $translate.instant(error));
								}
							}
							return $translate.instant(mCtrl.results[__index].message) + " - " + output.join('; ')
						}
					}
					return $translate.instant( mCtrl.results[__index].message);
				},
				cellRenderer: function(params) {
					var __index = params.data.__index;
					var label = 'Ready to import';
					if (!self.results[__index]) {
						return '<span class="label label-default">' + $translate.instant('Ready to import') + '</span>';
					} else {
						if (self.results[__index].created) {
							return '<span class="label label-success">' + $translate.instant('Created') + '</span>';
						}
						if (self.results[__index].updated) {
							return '<span class="label label-info">' + $translate.instant('Updated') + '</span>';
						}
						if (self.results[__index].unchanged) {
							return '<span class="label label-info">' + $translate.instant('Unchanged') + '</span>';
						}
					}
					return '<span class="text-danger" title="'+params.value+'">' + $translate.instant(mCtrl.results[__index].message) + '</span>';
				},
				filter:'text',
			}
		]
	});

	visible_csv_columns = {};
	for (var fieldname in this.import_config.columns) {
		for (var i in this.import_config.columns[fieldname]) {
			var column = this.import_config.columns[fieldname][i];
			if (self.importColumns.indexOf(column) == -1) {
				self.importColumns.push(column);
				self.columnFieldnames[column] = [fieldname];
			} else {
				self.columnFieldnames[column].push(fieldname)
			}
			if (visible_csv_columns[column]) continue;
			visible_csv_columns[column]=true;
			self.gridOptions.columnDefs.push((function(fieldname){return {
				headerName: column, 
				field: column,
				cellClass: function(params) { 
					var __index = params.data.__index;
					if (self.results[__index] && self.results[__index].data) {
						if (self.results[__index].data[fieldname]) return 'bg-danger';
					}
				},
				cellRenderer: function(params) {
					var tooltip = null;
					var __index = params.data.__index;
					if (self.results[__index] && self.results[__index].data) {
						if (self.results[__index].data[fieldname]) {
							tooltip = $translate.instant(self.results[__index].data[fieldname]);
						}
					} 
					if (tooltip) {
						return '<div title="' + tooltip + '" style="position:absolute;top:0;left:0;right:0;bottom:0"></div>'+params.value
					} else {
						return typeof params.value != "undefined"? params.value : "";
					}
				}
			}})(fieldname))
		}
	}
	this.message = null;


	this.form = FormService.createForm({
		layout: ['edit', ['options-0', 'options-1', /*'options-2',*/ 'options-3']],
		submit: function(data) {
			self.message = null;
			self.results.length = 0;
			if (self.items.length == 0) {
				return $q.reject({data:{code: 400, message: 'No data found in the provided file.'}});
			}
			return self.Class.import_all({preset: self.preset, objects:self.items, group:self.fieldGroup, merge_objects:self.values.merge_objects, delete_unlisted: self.values.delete_unlisted, dry_run: self.values.dry_run, ignore_errors: self.values.ignore_errors}).then(function(result){
				// success
				//$state.go('module.list');
				self.results = result
				if (self.results.length > self.items.length) {
					self.deleted_items.length = 0;
					[].push.apply(self.deleted_items, self.results.slice(self.items.length).map(function(item){return item.data}))
				}
				self.gridOptions.api.refreshView();
				return {__callstatus:{message:'The data has been successfully imported.'}};
			}).catch(function(error){
				if (error.data.code >= 100) {
					self.results = error.data.data
					if (self.results.length > self.items.length) {
						self.deleted_items.length = 0;
						[].push.apply(self.deleted_items, self.results.slice(self.items.length).map(function(item){return item.data}))
					}
					self.gridOptions.api.refreshView();
				}
				return $q.reject(error);
			});
		},
		params: [
			/*{
				"title": "Paste the CSV file content here",
				"type": "TextField",
				"name": "csv_text",
				"groups": ["edit"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
				"client": {"placeholder":"CSV file contents"},
			},*/
			{
				"title": "Update existing objects",
				"type": "BooleanField",
				"name": "merge_objects",
				"groups": ["options-0"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
			},
			{
				"title": "Skip incorrect entries",
				"type": "BooleanField",
				"name": "ignore_errors",
				"groups": ["options-1"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
			},
			/*{
				"title": "Delete unlisted objects",
				"type": "BooleanField",
				"name": "delete_unlisted",
				"groups": ["options-2"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
			},*/
			{
				"title": "Dry run",
				"type": "BooleanField",
				"name": "dry_run",
				"groups": ["options-3"],
				"required": false,
				"visible": 'true',
				"editable": 'true',
			},
		]
	}, this.values)


	this.parse = function(text) {
		var self = this;
		var i;
		self.items.length = 0;
		self.deleted_items.length = 0;
		self.results.length = 0;

		//text = text.replace(/("[^"]+")([^\t])/mg, "$1");
		var result = self.result = Papa.parse(text, {header: true, skipEmptyLines: true})
		var data = result.data;  // TODO manage errors and meta info

		

		// parse data
		for (i in data) {
			line = data[i]
			var object = self.Class.getObjectPayload(self.TemplateObject, self.fieldGroup)
			object.__index = i;  // to get mctrl.results[__index]
			for (var fi in result.meta.fields) {
				var fname = result.meta.fields[fi];
				if (typeof line[fname] != "undefined") {
					object[fname] = line[fname].replace(/[\r\n]/mg, '');
				}
			}
			self.items.push(object)
		}
	}

	$scope.$watch(function(){return self.values.csv_text}, function(){
		self.parse(self.values.csv_text);
		if (self.gridOptions.api) self.gridOptions.api.setRowData(self.items);
	}, true)

	
	this.cancelImport = function() {
		$state.go('module.list');
	}

	this.saveReportCSV = function() {
		if (self.gridOptions.api) {
			var params = {
				fileName: self.name + '-import.csv',
				columnSeparator: ';',
			}
			self.gridOptions.api.exportDataAsCsv(params);
		}
	}

	this.detectPaste = function($event) {
		if (($event.ctrlKey || $event.metaKey) && $event.keyCode==86){
			$timeout(function(){self.activeTab = 1;});
		}
	}

	this.readFile = function (file) {
        var deferred = $q.defer();

		var reader = new FileReader()
        reader.onload = function(e){
            deferred.resolve({
    			mime: file.type,
				filename: file.name,
				data: e.target.result,
				title: file.name.replace(/\.[a-z0-9]+$/, '').replace(/[_\\-]/g, ' ')
	    	});
        }
        reader.onerror = function(e) {
            deferred.reject(e);
        }
        reader.readAsDataURL(file);

        return deferred.promise;
    }
	
	self.upload_is_busy = false;
    this.uploadFiles = function(files) {
		var slice = Array.prototype.slice;
		self.upload_is_busy = true;

        return $q.all(slice.call(files, 0).map(self.readFile)).then(function(values){
			
			// sent in to self.Class to decode
			if(values.length){
				self.Class.parseCsvSelectedString({
					import_data: values[0].data
				}).then(function(data){
					
					//console.table(data);
					//result = JSON.parse(result);
					//self.values.csv_text = result;
					//self.parse(self.values.csv_text);
					self.items.length = 0;
					for (i in data) {
						line = data[i]
						var object = self.Class.getObjectPayload(self.TemplateObject, self.fieldGroup)
						object.__index = i;  // to get mctrl.results[__index]
						for (var ci in self.importColumns) {
							var column = self.importColumns[ci];
							object[column] = line[column];
						}
						self.items.push(object)
					}
					if (self.gridOptions.api) 
						self.gridOptions.api.setRowData(self.items);

					self.activeTab = 1;

				}).catch(function(error){
					if (error.data.code >= 100) {
						self.results = error.data.data
						if (self.results.length > self.items.length) {
							self.deleted_items.length = 0;
							[].push.apply(self.deleted_items, self.results.slice(self.items.length).map(function(item){return item.data}))
						}
						self.gridOptions.api.refreshView();
					}
					return $q.reject(error);
				});
			}
			
			self.upload_is_busy = false;
    	}).catch(function(e){
    		self.message={type:'danger', body:e}
			self.upload_is_busy = false;
    	});
    }


	
	window.mCtrl = this;  // debug
}


angular.module('admin')
.controller('ModuleImportController', ModuleImportController)
